import React, { useState } from "react";
import { CssBaseline, Toolbar, Box } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";

import { theme } from "../../theme";
import SideBar from "./SideBar";
import NavBar from "./NavBar";
import CustomBreadcrumbs from "../Custom/CustomBreadcrumbs";
import NotFoundScreen from "../Custom/NotFoundScreen";
import CustomSnackbars from "../Custom/Snackbars/Snackbars";
import useUserProfileCheck from "../../hooks/useUserProfileCheck";
import CustomNotifications from "../Custom/Notifications/CustomNotifications";
import useNotification from "../../hooks/useNotification";
import LoadingScreen from "../Custom/LoadingScreen";

export default function MainLayout(props) {
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const {
    children,
    breadcrumbs,
    errorCode,
    title,
    dealerID,
    factoryID,
    onlyAdmin,
  } = props;

  /**
  |--------------------------------------------------
  | States
  |--------------------------------------------------
  */
  const [mobileOpen, setMobileOpen] = useState(false);

  /**
  |--------------------------------------------------
  | Use Check Profile
  |--------------------------------------------------
  */
  const [loading, userProfile] = useUserProfileCheck({
    dealerID,
    factoryID,
    onlyAdmin,
  });
  const [notiLoading] = useNotification();

  /**
  |--------------------------------------------------
  | Drawer Handler
  |--------------------------------------------------
  */
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  if (errorCode === 404) {
    return <NotFoundScreen />;
  }

  if (loading || notiLoading) {
    return (
      <Box bgcolor="grey.800" height="100vh">
        <LoadingScreen />
      </Box>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      {/* <Helmet>
        <meta charSet="utf-8" />
        <title>IoT Zenter Dashboard</title>
      </Helmet> */}
      <Box display="flex">
        <CssBaseline />
        <NavBar handleDrawerToggle={handleDrawerToggle} />
        <SideBar
          handleDrawerToggle={handleDrawerToggle}
          mobileOpen={mobileOpen}
          userProfile={userProfile}
          dealerID={dealerID}
        />

        <Box flexGrow={1} padding={3} className="overflow-hidden">
          <Toolbar />
          <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
          {children}
        </Box>
      </Box>
      <CustomSnackbars />
      <CustomNotifications />
    </ThemeProvider>
  );
}
